import { useState, useEffect } from "react";
import { Button } from "../lib/common/components/CustomButton";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../lib/common/components/CustomCard";
import logo from "../assets/svg/daburTreeLogo.png";
import microsoft from "../assets/svg/daburIcon.svg";
import { useMsal } from "@azure/msal-react";
import { useDispatch } from "react-redux";
import { setUser } from "../lib/redux/actions";
import Cookies from "js-cookie";
import {  trackEvent, trackException } from "../lib/utils/telemetryService";
import copilotIcon from "../assets/svg/copilot.svg";
export default function SignIn() {
  const { instance } = useMsal();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    const accounts = instance.getAllAccounts();
    if (accounts?.length > 0) {
      const userDataFromToken = {
        username: accounts[0]?.username,
        name: accounts[0]?.name,
        email: accounts[0]?.username,
        idToken: accounts[0]?.idToken,
      };

      dispatch(setUser(userDataFromToken));
      //  localStorage.clear()
    }
  }, [instance, dispatch]);

  const handleLogin = async () => {
    setIsLoading(true);
    setError("");
    try {
      const res = await instance.loginPopup({
        prompt: "select_account",
      });
      Cookies.set("idToken", res.idToken, {
        secure: true,
        sameSite: "Strict",
        expires: 1,
        path: "/",
      });
      if (res.idTokenClaims.exp) {
        const expiryDate = new Date(res.idTokenClaims.exp * 1000);
        Cookies.set("tokenExpiry", expiryDate.toISOString(), {
          expires: 1,
          path: "/",
          sameSite: "Strict",
          secure: true
        });
      }

      trackEvent({ name: "Login Success" }, { username: res.account.username });

      // You can handle login success here (e.g., redirect or fetch user profile)
    } catch (error) {
      if (error.errorCode === "user_cancelled") {
        setError("Login was cancelled. Please try again.");
      } else {
        setError("Login failed. Please try again.");
      }
      trackException({ exception: error });
      console.warn("Login error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleCopilotRedirect = () => {
    window.open("https://copilot.microsoft.com", "_blank");
  };
  

  return (
    <div className="flex h-screen flex-col overflow-y-auto p-6 items-center justify-start md:justify-center bg-gradient-to-b from-white to-[#E7EEE9] pb-8 md:pb-6">
      <div className="mb-[70px] flex flex-col items-center gap-4 flex-shrink-0">
        <div className="flex flex-col relative h-24 w-64 flex items-center justify-center">
          <img
            src={logo}
            alt="Dabur Logo"
            className="object-contain h-[110px] w-64"
            loading="eager"
          />
          <p className="text-[24px] font-normal text-center text-[#000000]">
            <span className="font-bold">AI</span> Companion
          </p>
        </div>
      </div>
      <div className="flex md:flex-row flex-col items-center justify-center gap-6 md:gap-12 flex-shrink-0 w-full">
      <div>
      <p className="text-[16px] font-medium text-center text-[#000000BF]">For Nominated Users</p>
        <Card className="w-full flex flex-col justify-between max-w-md p-4 md:p-6 bg-white/80 backdrop-blur-sm shadow-[0px_1px_2px_0px_#1018280F,0px_1px_3px_0px_#1018281A]border-0">
          <CardHeader className="space-y-1">
            <CardTitle className=" md:text-[30px] text-[26px] font-normal text-center text-[#1B5C29]">
              Welcome to DaburGPT
            </CardTitle>
            <CardDescription className="text-center text-black text-[16px] font-medium">
              Sign in with Dabur's credentials to access DaburGPT
            </CardDescription>
          </CardHeader>
          <div>
            <CardContent className="flex flex-col gap-4">
              {error && (
                <div className="p-3 text-sm text-red-600 bg-red-50 rounded-md text-center">
                  {error}
                </div>
              )}
              <Button
                variant="outline"
                className="
    w-full h-12 flex items-center justify-center gap-2
    bg-white hover:bg-gray-50
    border border-[#D0D5DD]
    text-[#1B5C29] hover:text-[#1B5C29]
    rounded-[8px]
    focus-visible:ring-0 focus-visible:ring-offset-0
    outline-none
  "
                onClick={handleLogin}
                disabled={isLoading}
              >
                {isLoading ? (
                  <div className="h-5 w-5 animate-spin rounded-full border-b-2 border-[#1B5C29]" />
                ) : (
                  <>
                    <img
                      src={microsoft}
                      alt="Microsoft logo"
                      width={40}
                      height={40}
                      className="mr-1 inline-block"
                    />

                    
                    <span className="cursor-pointer text-black text-[16px] font-bold">
                      Sign in with Dabur
                    </span>
                  </>
                )}
              </Button>
            </CardContent>
            <CardFooter className="flex flex-col">
              <p className="text-[14px] text-center text-[#000000BF] mt-2">
                By signing in, you agree to our terms of service and privacy
                policy
              </p>
            </CardFooter>
          </div>
        </Card>
      </div>

        <div>
        <p className="text-[16px] font-medium text-center text-[#000000BF]">For All Users</p>
        
        <Card className="w-full flex flex-col justify-between max-w-md p-4 md:p-6 bg-white/80 backdrop-blur-sm shadow-[0px_1px_2px_0px_#1018280F,0px_1px_3px_0px_#1018281A]border-0">
          <CardHeader className="space-y-1">
            <CardTitle className="text-[26px] md:text-[30px] font-normal text-center text-[#1B5C29]">
              Welcome to Dabur Copilot
            </CardTitle>
            <CardDescription className="text-center text-black text-[16px] font-medium">
              Sign in with Dabur's credentials to access Copilot
            </CardDescription>
          </CardHeader>

          <div>
            <CardContent className="flex flex-col gap-4">
              <Button
                variant="outline"
                className="
                  w-full h-12 flex items-center justify-center gap-2
                  bg-white hover:bg-gray-50
                  border border-[#D0D5DD]
                  text-[#1B5C29] hover:text-[#1B5C29]
                  rounded-[8px]
                  focus-visible:ring-0 focus-visible:ring-offset-0
                  outline-none
                "
                onClick={handleCopilotRedirect}
                disabled={isLoading}
              >
                <img
                  src={copilotIcon}
                  alt="Microsoft logo"
                  width={20}
                  height={20}
                  className="mr-2 inline-block"
                />
                <span className="cursor-pointer text-black text-[16px] font-bold">
                  Switch to Dabur Copilot
                </span>
              </Button>
            </CardContent>
            <CardFooter className="flex h-[72px] flex-col">
              <p className="text-[14px] text-center text-[#000000BF] mt-2">
                Powered by Microsoft{" "}
                <img
                  src={copilotIcon}
                  alt="Microsoft logo"
                  width={15}
                  height={15}
                  className="ml-1 inline-block"
                />
              </p>
            </CardFooter>
          </div>
        </Card>
        </div>
      </div>
    </div>
  );
}
